import { PrimaryButton } from '@/components';
import { useTranslation } from 'react-i18next';

interface CreateFolderFormProps {
  inputRef: React.RefObject<HTMLInputElement | null>;
  value: string;
  error: string;
  isSubmitting: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

/** Inline form for naming and confirming a new folder. */
export function CreateFolderForm({
  inputRef,
  value,
  error,
  isSubmitting,
  onChange,
  onKeyDown,
  onSubmit,
  onCancel,
}: CreateFolderFormProps) {
  const { t } = useTranslation();

  return (
    <div className="border-border bg-surface-darker/40 flex flex-col gap-2 rounded-lg border p-3 sm:flex-row sm:items-center">
      <input
        ref={inputRef}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        maxLength={255}
        placeholder={t('documents.folderForm.createPlaceholder')}
        aria-label={t('documents.folderForm.nameLabel')}
        className="border-border bg-field text-onfield placeholder:text-onfield/40 focus:ring-primary/30 min-w-0 flex-1 rounded-sm border px-3 py-2 text-sm focus:ring-2 focus:outline-none"
      />
      <div className="flex items-center gap-2">
        <PrimaryButton
          size="sm"
          onClick={onSubmit}
          disabled={value.trim().length === 0}
          isLoading={isSubmitting}
        >
          {t('documents.folderForm.createConfirm')}
        </PrimaryButton>
        <button
          type="button"
          onClick={onCancel}
          disabled={isSubmitting}
          className="text-muted hover:text-onsurface px-3 py-1.5 text-sm font-medium transition-colors disabled:opacity-50"
        >
          {t('documents.folderForm.cancel')}
        </button>
      </div>
      {error ? (
        <p className="text-error text-sm sm:basis-full">
          {error}
        </p>
      ) : null}
    </div>
  );
}
